import "core-js/modules/es.array.push.js";
import { computed, defineComponent, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import { logout } from "@/service/canvas";
export default defineComponent({
  name: "header-bar",
  components: {},
  setup() {
    const route = useRoute();
    const router = useRouter();
    const store = useStore();
    const showUserInfo = ref(false);
    const showVip = ref(false);
    const active = computed(() => {
      return route.name;
    });
    const userInfo = computed(() => {
      return store.state.userInfo;
    });
    const showChatSlider = computed(() => {
      return store.state.showChatSlider;
    });
    const isLogin = computed(() => {
      return store.state.isLogin;
    });
    const isMobile = computed(() => {
      return store.state.isMobile;
    });
    return {
      isMobile,
      route,
      active,
      router,
      userInfo,
      isLogin,
      showUserInfo,
      showChatSlider,
      showVip,
      login() {
        if (isLogin.value) return;
        store.commit("SET_SHOW_LOGIN", true);
      },
      toggle() {
        store.commit("SET_CHAT_SLIDER", !showChatSlider.value);
      },
      goChat() {
        router.push({
          name: "chat"
        });
      },
      goCollect() {
        router.push({
          name: "collect",
          query: {
            tab: "0"
          }
        });
      },
      handleCommand(cm) {
        switch (cm) {
          case "userInfo":
            store.commit("SET_SHOW_USERINFO", true);
            break;
          case "upgrade":
            store.commit("SET_SHOW_VIP", true);
            break;
          case "logout":
            store.dispatch("logout");
        }
      }
    };
  }
});